import { denormalize } from "normalizr";

import { debtors } from "../../../api/schema";

export default state => {
  try {
    const items = state.debtors.ids;

    const denormalized = denormalize(
      { items },
      { items: [debtors] },
      state.entities
    );
    return denormalized.items;
  } catch (err) {
    return [];
  }
};
